import React from "react";
import { SurveyManagement } from "@components/Survey";

export default function SurveyIndex() {
  return <SurveyManagement />;
}
